export default __webpack_public_path__ + "media/images/logos/logo_dark-fdae9653d73330a654228bd3a08dd420.png";